import { useNavigate } from 'react-router';
import login_Service from '../../../api/services/login_Service';
import { useEffect, useState } from 'react';
import forwardArrow from "../../../assets/icons/forward.svg";
import Modal from "../../common/components/modal/index";
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";

const Rules = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rules, setRules] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const loggedInParam = queryParams.get("loggedIn");
  const loggedIn = loggedInParam === "true";
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleClick = () => {
    handleSongClick();
    navigate('/dashboard');
  };

  const handleButtonClick = (redirectToDashboard) => {
    if (redirectToDashboard) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    setIsLoading(true);
    login_Service.rule()
      .then(response => response.json())
      .then(data => {
        if (data) {
          setRules(data)
          setIsLoading(false);
        }
      })
      .catch(err => {
        console.log(err)
      });
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div
      className="relative flex h-[100dvh] min-h-[100dvh] w-full min-w-0 flex-col overflow-hidden bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10"
      style={{ minHeight: '100svh' }}
    >

      {/* Header */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-6 px-4 shadow-sm">
        <div className="flex justify-start items-center">
          <button
            className="w-10 h-10 mr-4 flex justify-center items-center text-white rounded-xl active:bg-white/20"
            onClick={handleClick}
          >
            {loggedInParam ? '' : <IoIosArrowBack size={25} />}
          </button>
          <div className="flex-1 text-center mr-10">
            <h1 className="text-white font-bold text-xl">Rules & Regulations</h1>
            <p className="text-emerald-100 text-xs font-medium">Terms & Conditions</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-0 flex-1 overflow-y-auto bg-white/50 p-2">
        <div className="space-y-1">
          {rules.map((rule, index) => (
            <div key={rule.ruleId} className="bg-white/80 rounded-2xl p-4 border border-[#228B22]/20 shadow-sm">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#228B22] text-white rounded-full flex items-center justify-center font-bold text-sm mr-4 flex-shrink-0">
                  {index + 1}
                </div>
                <h3 className="font-bold text-[#228B22] text-lg leading-tight">{rule?.ruleTitle}</h3>
              </div>
              <div className="ml-12">
                <p className="text-gray-700 text-sm leading-relaxed">{rule?.descriptions}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Buttons */}
      {loggedIn && (
        <div
          className="relative z-10 shrink-0 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] px-3 pt-3 shadow-sm"
          style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.75rem)' }}
        >
          <div className="flex justify-center items-center space-x-4">
            <button
              className="py-2 px-6 rounded-xl bg-white/20 text-white font-semibold active:bg-white/30 border border-white/30"
              onClick={() => handleButtonClick(false)}
            >
              ထွက်မည်
            </button>
            <button
              className="py-2 px-8 rounded-xl bg-gradient-to-r from-[#FFD700] to-yellow-400 text-gray-900 font-bold shadow-sm border border-yellow-300 active:opacity-90"
              onClick={() => handleButtonClick(true)}
            >
              သဘောတူပါသည်
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rules;
